import React from 'react';

import { IconArrowBlackRight, getIcon } from '../Icons';

import './CardSection.scss';

interface Card {
  id: number;
  title: string;
  description: string;
  icon: string;
  link: string;
  external?: boolean;
}

export interface CardSectionProps {
  cardList: Card[];
  title: string;
}

export default function GridCard(props: CardSectionProps): React.ReactElement {
  const { title, cardList } = props;

  return (
    <div className="card-section">
      {title && <h4>{title}</h4>}
      <div className="card-section__container">
        {cardList.map((card) => {
          return (
            <a className="card-section__item" key={card.id} href={card.link} target={card.external ? '_blank' : null} rel="noreferrer">
              <span>{getIcon(card.icon)}</span>
              <h5>
                {card.title} <IconArrowBlackRight className="card-section__item--icon" />
              </h5>
              <p>{card.description}</p>
            </a>
          );
        })}
      </div>
    </div>
  );
}
